// @flow

import styled from '@emotion/styled'
import * as React from 'react'
import Slider from 'react-slick'

import { colors, media } from '@toggl/style'

import * as Responsive from '../responsive'

import 'slick-carousel/slick/slick.css'

type Props = {
  children: React.Node[],
}

export function CarouselDotMobile({ children }: Props) {
  const [active, setActive] = React.useState(0)

  const settings = {
    centerMode: true,
    infinite: true,
    slidesToShow: 1,
    speed: 500,
    focusOnSelect: true,
    arrows: false,
    centerPadding: '20px',
    beforeChange: (oldIndex, newIndex) => {
      setActive(newIndex)
    },
  }

  return (
    <Root active={active}>
      <Responsive.MobileOnly>
        <>
          <Slider {...settings}>
            {React.Children.map(children, (item, index) => {
              return (
                <Slide
                  isFirst={index === 0}
                  isLast={index === React.Children.count(children) - 1}
                >
                  {item}
                </Slide>
              )
            })}
          </Slider>
          <Dots>
            {React.Children.map(children, (item, index) => (
              <Dot active={index === active} onClick={() => setActive(index)} />
            ))}
          </Dots>
        </>
      </Responsive.MobileOnly>

      <Responsive.DesktopOnly>{children}</Responsive.DesktopOnly>
    </Root>
  )
}

const Dot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${(p) => (p.active ? colors.beige : colors.purple60)};
`

const Dots = styled.div`
  margin: 20px auto;
  display: flex;
  justify-content: space-between;
  align-content: stretch;
  max-width: 10%;

  ${media.mq[1]} {
    display: none;
  }
`

const Slide = styled.div`
  padding: 0 5px;
`

const Root: React.ComponentType<any> = styled.div`
  max-width: 100%;
  ${media.mq[1]} {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    flex-wrap: wrap;
  }
  ${media.mq[2]} {
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  .slick-slide.slick-cloned:nth-child(2) {
    opacity: 0;
  }
`
